import { render, staticRenderFns, recyclableRender, components } from "./newPersonnel.vue?vue&type=template&id=2e7fd406&scoped=true&"
var renderjs
import script from "./newPersonnel.vue?vue&type=script&lang=js&"
export * from "./newPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./newPersonnel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newPersonnel.vue?vue&type=style&index=1&id=2e7fd406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7fd406",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/newPersonnel/newPersonnel.vue"
export default component.exports